import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from '../../actions';

import styled from 'styled-components';
import {
  StyledStepNum,
  StyledTable,
  StyledPopover,
} from './custom-styled-components/_MyCustomSC';
import { Radio, Icon, InputNumber, Tooltip } from 'antd';

const StyledDiv = styled.div`
  width: auto;
  display: flex;
  flex-direction: row;
  justify-content: start;
  align-items: center;
`;

const StyledBottomTr = styled.tr`
  background: #fef5e7;
  height: 91px;
  padding-left: 18px;
`;

const StyledRadioGroup = styled(Radio.Group)`
  display: block;
  margin-top: 10px;
`;
const StyledRadio = styled(Radio)`
  display: block;
  font-size: 13px;
  color: #627b93;
  padding-left: 5px;
  margin: 0px 0px 7px 20px;
`;

/**
 * @component
 * @category Form Page
 * @name CustomService
 * @description Custom service on form page
 * <br> <br>
 * **Example**
 * ```js
 *   <CustomService />
 * ```
 */
class CustomService extends Component {
  state = {};

  // componentWillMount = () => {};

  /**
   * @description this is invoked when brokerage or bond radio group is changed
   * <br> <br>
   * **onRadioGroupChange(e, type) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | e             | Event         | mouse event |
   * | type          | string        | Either `brokerage` or `bond` |
   * Returns: Type: void
   */
  onRadioGroupChange = (e, type) => {
    if (type === 'brokerage') {
      // this.setState({
      //   brokerageValue: e.target.value
      // });
      this.props.saveCustomService({
        isBrokerageFirstOptionSelected: e.target.value === 1,
      });
    } else {
      // this.setState({
      //   bondValue: e.target.value
      // });
      this.props.saveCustomService({
        isBondFirstOptionSelected: e.target.value === 1,
      });
    }
  };

  /**
   * @description input number field for entering no. of commodity
   * <br> <br>
   * **onInputNumberChange(value) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | value         | number        | entered no. of commodity. default is `1` |

   * Returns: Type: void
   */
  onInputNumberChange = (value) => {
    this.props.saveCustomService({ noOfCommodity: value ? value : 1 });
  };

  render() {
    const { brokerageValue, bondValue, noOfCommodity } = this.props;

    // console.log("custom service: ", brokerageValue, bondValue, noOfCommodity);

    return (
      <StyledDiv className="form-custom-service">
        <StyledTable>
          <tbody>
            <tr>
              <th>
                <StyledStepNum>3</StyledStepNum>
                <span style={{ lineHeight: '19px', color: '#373848' }}>
                  <span style={{ fontSize: '15px', fontWeight: 600 }}>
                    Customs services
                  </span>
                  <span
                    style={{
                      fontSize: '11px',
                      paddingLeft: '6px',
                      fontWeight: 400,
                    }}
                  >
                    All international shipments require customs clearance. Some
                    imports also require a customs bond
                  </span>
                </span>
              </th>
            </tr>
            <tr>
              <td>
                <div>
                  <div style={{ height: '102px' }}>
                    <span style={{ fontSize: '13px', fontWeight: 600 }}>
                      Add customs brokerage services to your quote?
                    </span>
                    <StyledRadioGroup
                      onChange={(e) => this.onRadioGroupChange(e, 'brokerage')}
                      value={brokerageValue ? 1 : 2}
                      style={{ color: '#627b93' }}
                    >
                      <StyledRadio value={1}>
                        Yes, I need customs clearance for&nbsp;
                        <InputNumber
                          style={{ height: '30px', width: '60px' }}
                          min={1}
                          value={noOfCommodity ? noOfCommodity : 1}
                          onChange={this.onInputNumberChange}
                        />
                        &nbsp;commodities
                        <StyledPopover
                          title={<Icon type="question-circle" />}
                          content={
                            <div style={{ maxWidth: '400px' }}>
                              <div>
                                If you ship 10 boxes full of teddy bears, the
                                number of commodities is one. If you ship 10
                                boxes, each with a different product, then you
                                ship 10 commodities
                              </div>
                            </div>
                          }
                        >
                          <Icon
                            type="question-circle"
                            style={{ marginLeft: '2px' }}
                          />
                        </StyledPopover>
                        {/* <Tooltip
                          placement="top"
                          autoAdjustOverflow
                          title={
                            <div style={{ maxWidth: "600px" }}>
                              <div>
                                If you ship 10 boxes full of teddy bears, the
                                number of commodities is one. If you ship 10
                                boxes, each with a different product, then you
                                ship 10 commodities
                              </div>
                            </div>
                          }
                          overlayStyle={{}}
                        >
                          <Icon
                            type="question-circle"
                            style={{ marginLeft: "2px" }}
                          />
                        </Tooltip> */}
                      </StyledRadio>
                      <StyledRadio value={2}>
                        No, I have my own customs broker who will handle customs
                        brokerage for me
                      </StyledRadio>
                    </StyledRadioGroup>
                  </div>
                  {brokerageValue && (
                    <div style={{ height: '84px' }}>
                      <span style={{ fontSize: '13px', fontWeight: 600 }}>
                        Purchase a customs bond?
                      </span>
                      <StyledRadioGroup
                        onChange={(e) => this.onRadioGroupChange(e, 'bond')}
                        value={bondValue ? 1 : 2}
                      >
                        <StyledRadio value={1}>Yes</StyledRadio>
                        <StyledRadio value={2}>
                          No, I already have one
                        </StyledRadio>
                      </StyledRadioGroup>
                    </div>
                  )}
                </div>
              </td>
            </tr>

            <StyledBottomTr>
              <td>
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <span>
                    <Icon type="info-circle" style={{ color: '#f5a213' }} />
                  </span>
                  <span style={{ marginLeft: '5px' }}>
                    <span
                      style={{
                        fontSize: '13px',
                        color: '#373848',
                        fontWeight: 600,
                      }}
                    >
                      Please Note:Duties and taxes will not be included in the
                      quote.
                    </span>
                    <div
                      style={{
                        fontSize: '11px',
                        color: '#3f536e',
                        fontWeight: 400,
                      }}
                    >
                      Duties &amp; taxes are imposed by the government. The
                      customs broker or freight forwarder will contact you to
                      collect payment.
                    </div>
                    <hr
                      style={{
                        borderColor: '#ffdfac',
                        height: '2px',
                        border: 0,
                        borderTop: '1px solid #ffdfac',
                      }}
                    />
                    <div
                      style={{
                        fontSize: '11px',
                        color: '#3f536e',
                        fontWeight: 400,
                      }}
                    >
                      Personal goods and certain hazardous materials cannot be
                      shipped through Prime Freight.
                    </div>
                  </span>
                </div>
              </td>
            </StyledBottomTr>
          </tbody>
        </StyledTable>
      </StyledDiv>
    );
  }
}

CustomService.propTypes = {
  /**
   * whether custom brokerage services' radio first option selected
   */
  brokerageValue: PropTypes.bool,
  /**
   * whether customs bond's radio first option selected upon select on custom brokerage services' radio first option
   */
  bondValue: PropTypes.bool,
  /**
   * custom clearance for how many no. of commodities
   */
  noOfCommodity: PropTypes.number,
};
const mapStateToProps = (state) => {
  return {
    // showForm: state.form.showForm,
    brokerageValue: state.form.customService.isBrokerageFirstOptionSelected,
    bondValue: state.form.customService.isBondFirstOptionSelected,
    noOfCommodity: state.form.customService.noOfCommodity,
  };
};

export default connect(mapStateToProps, actions)(CustomService);
